module.exports = __webpack_public_path__ + "static/media/danfe_icon.ff9da81a.webp";